import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Card, Typography, Button, Space, Row, Col } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import BankConnectService from '../admin-settings/bank-accounts/services';

const { Text, Title } = Typography;

const OnlinePaymentPromo = () => {
  const [isOnlinePaymentEnabled, setIsOnlinePaymentEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkOnlinePaymentStatus();
  }, []);

  const checkOnlinePaymentStatus = () => {
    BankConnectService.getAccount()
      .then((res) => {
        try {
          let result = res.data;
          if (result.success && result.data) {
            const account = result.data;
            const isActive = account.status === 'active' && account.is_online_payment_active === true;
            setIsOnlinePaymentEnabled(isActive);
          } else {
            setIsOnlinePaymentEnabled(false);
          }
        } catch (error) {
          console.log('Error checking online payment status:', error);
          setIsOnlinePaymentEnabled(false);
        } finally {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log('Error fetching bank connect account:', error);
        setIsOnlinePaymentEnabled(false);
        setLoading(false);
      });
  };

  // Don't show if online payment is already enabled or still loading
  if (loading || isOnlinePaymentEnabled) {
    return null;
  }

  const paymentMethods = [
    'amex',
    'diners',
    'discover',
    'googlePay',
    'jcb',
    'mastercard',
    'unionpay',
    'visa'
  ];

  const cdnBaseUrl = 'https://cdn.gridbind.com/images/online-payment-method/small';

  return (
    <Card className="mb-3 bg-100">
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} md={16}>
          <Space orientation="vertical" size="small" style={{ width: '100%' }}>
            <Title level={5} className="mb-0">
              Accept Online Payments
            </Title>
            <Text type="secondary" style={{ display: 'block' }}>
              Enable online payments and let your customers pay invoices instantly with credit cards, debit cards, and other payment methods.
            </Text>
            <div style={{ marginTop: '0.75rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem', alignItems: 'center' }}>
              {paymentMethods.map((method) => (
                <img
                  key={method}
                  src={`${cdnBaseUrl}/${method}.svg`}
                  alt={method}
                  style={{
                    height: '24px',
                    width: 'auto',
                    objectFit: 'contain',
                    opacity: 0.8
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              ))}
            </div>
          </Space>
        </Col>
        <Col xs={24} md={8} style={{ textAlign: 'right' }}>
          <Link to="/bank-accounts">
            <Button type="primary" icon={<ArrowRightOutlined />} iconPlacement="end">
              Set Up Online Payments
            </Button>
          </Link>
        </Col>
      </Row>
    </Card>
  );
};

export default OnlinePaymentPromo;

